import { Navigate, Outlet } from 'react-router-dom'

import Loading from '@/components/loading'
import { useAuth } from '@/hooks/use-auth'
import { useCompanies } from '@/hooks/use-companies'

import { routes } from '../../config'

export function CompaniesRoute() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth()
  const { isCompaniesLoading, isCompaniesError } = useCompanies()

  if (isAuthLoading || (isAuthenticated && isCompaniesLoading))
    return <Loading />

  if (isAuthenticated && !isCompaniesError) {
    return <Outlet />
  }

  return <Navigate to={routes.Login()} replace />
}
